module.exports = __webpack_public_path__ + "img/home-icon-dark.554dd643.svg";